import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServicioService {
  private apiUrl = 'https://thedetailer.up.railway.app/api/servicios';
  private http = inject(HttpClient);

  getServicios(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl);
  }

  createServicio(servicio: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, servicio);
  }

  updateServicio(id: number, servicio: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, servicio);
  }

  deleteServicio(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }
}